import { NO_LOWER_CASE_REGEX } from './RegEx';

function isPrintableAscii(str, allowEmpty = true) {
  if (allowEmpty && !str) {
    return true;
  }

  return /^[ -~]+$/.test(str);
}

function toLowerCase(str) {
  if (!str) {
    return '';
  }
  return str.toLowerCase().replace(NO_LOWER_CASE_REGEX, '');
}

export { isPrintableAscii, toLowerCase };
